export default __webpack_public_path__ + "media/Bamboo_right.fd5a2b09bf292f9a7ae23e77465b0f6d.svg";